import React from "react";
import cx from "classnames";
import { useLocation } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { Select } from "../index";
import s from "./styles.module.css";
import { FUNDED_COMPLIANCE_API_URLS, FundedComplianceAPI } from "../../../api/fundedCompliance";
import { FUNDS_API_URLS } from "../../../api/funds";

interface IComplianceWithdrawalStatusSelectProps {
  compliance_status: string;
  id: number;
  payment_status?: string;
}

interface IOptions {
  label: string | number;
  value: string | number | boolean;
  // size?: "small" | "medium";
}

export const COMPLIANCE_WITHDRAWAL_STATUS_OPTIONS: IOptions[] = [
  {
    label: "New",
    value: "new",
  },
  {
    label: "Process payment",
    value: "process_payment",
  },
  {
    label: "Under investigation",
    value: "under_investigation",
  },
  {
    label: "Canceled",
    value: "canceled",
  },
  {
    label: "Failed",
    value: "failed",
  },
  {
    label: "Payment denied",
    value: "payment_denied",
  },
  {
    label: "Sent for review",
    value: "sent_for_review",
  },
];

const ComplianceWithdrawalStatusSelect: React.FC<IComplianceWithdrawalStatusSelectProps> = ({
  payment_status,
  compliance_status,
  id,
}) => {
  const queryClient = useQueryClient();
  const { pathname } = useLocation();

  const { mutate: handleChnageStatus } = useMutation({
    mutationKey: [],
    mutationFn: async (compliance_status: string) => {
      const response = await FundedComplianceAPI.updateWithdrawalsRequest({
        id,
        compliance_status,
      });
      return response;
    },
    onSuccess: () => {
      // Update withdrawals in compliance page
      queryClient.invalidateQueries({
        queryKey: [FUNDED_COMPLIANCE_API_URLS.withdrawals],
      });
      // Update withdrawal list page
      queryClient.invalidateQueries({
        queryKey: [FUNDS_API_URLS.withdrawal_list],
      });
      // Update compliance trader profile page
      queryClient.invalidateQueries({
        queryKey: [FUNDED_COMPLIANCE_API_URLS.traderProfile],
      });
    },
  });

  const isDisabled =
    compliance_status === "payment_denied" ||
    compliance_status === "failed" ||
    ["paid", "canceled"].includes(payment_status as string) ||
    pathname.includes("fundedTraders");

  return (
    <Select
      disabled={isDisabled}
      baseSelectStyles={{
        className: cx(s.baseSelect, s[compliance_status]),
        classes: { root: s.rootBaseSelect },
      }}
      onChange={(e) => handleChnageStatus(e.target.value as string)}
      size="small"
      value={compliance_status || ""}
      options={COMPLIANCE_WITHDRAWAL_STATUS_OPTIONS.map((opt) => ({
        text: opt.label as string,
        name: opt.value,
      }))}
    />
  );
};

export default ComplianceWithdrawalStatusSelect;
